<template>
  <div class="search-criteria-box">
    <h4 class="tit-search-type is-bgc-red400">横幅</h4>
    <!-- <img src="/images/cmn/ico-width.png" class="img-fluid mx-auto" alt="" width="300" height="200"> -->
    <div class="search-radio-set">
      <template v-for="option in options">
      <input type="radio"
      :name="name"
      :id="`label3-${option.id}`"
      :key="`radio3-${option.id}`"
      :value="option.data"
      @change="updateValue(option.data, option.flag, option.price, option.secondprice, option.thirdprice)"
      v-bind:disabled="flag[option.id]==false"
      >
      <label :key="`label3-${option.id}`" :for="`label3-${option.id}`" v-html="option.value"></label>
    </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
    options: { type: Array },
    name: { type: String },
    flag: { type: Object },
  },
  methods: {
    updateValue: function(value, flag, price, secondprice=0,thirdprice=0) {
      this.$emit('WidthPrice', price);
      this.$emit('WidthSecondPrice', secondprice);
      this.$emit('WidthThirdPrice', thirdprice);
      this.$emit('WidthFlag', flag);
      this.$emit("input", value);
    }
  }
}
</script>